module.exports = __webpack_public_path__ + "img/iso_white.7017f40.svg";